import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    current: null,
};
export const currentTaskSlice = createSlice({
    name: "currentTask",
    initialState,
    reducers: {
        setCurrent: (state, action) => {
            state.current = action.payload;
        },
        completeCurrentTaskMaybe: (state, action) => {
            if (state.current === action.payload) {
                state.current = null;
            }
        },
    },
});
export const { setCurrent, completeCurrentTaskMaybe } = currentTaskSlice.actions;
export const selectCurrentTask = (state) => state.currentTask;
export default currentTaskSlice.reducer;
